import { Routes, Route, Navigate } from 'react-router-dom';
import { NotFound } from 'features/ecg/components/NotFound';
import { loadAnalytics } from '../features/analytics/segment';
import { Authenticator } from '../features/auth/components/Authenticator';
import { Clustering } from '../features/clustering/components/Clustering';
import { EcgAnalysis } from '../features/ecg/components/EcgAnalysis';
import { EcgList } from '../features/ecg/components/EcgList';
import { Page } from '../features/ecg/components/Page';
import { AppProviders } from './AppProviders';
import { Dashboard } from '../features/admin/components/Dashboard';
import { TaskPage } from '../features/admin/components/TaskPage';
import { AdminRoute } from './AdminRoute';
import { AnnotationTaskActive } from '../features/admin/components/dashboard/AnnotationTaskActive';
import { AnnotationTaskInactive } from '../features/admin/components/dashboard/AnnotationTaskInactive';
import { TaskForm } from '../features/admin/components/TaskForm';

loadAnalytics();

export const App: React.FC = () => {
  return (
    <AppProviders>
      <Page>
        <Authenticator>
          <Routes>
            <Route path='/admin' element={<AdminRoute />}>
              <Route index element={<Navigate to='dashboard' replace />} />
              <Route path='dashboard' element={<Dashboard />}>
                <Route index element={<AnnotationTaskActive />} />
                <Route path='active' element={<AnnotationTaskActive />} />
                <Route path='inactive' element={<AnnotationTaskInactive />} />
              </Route>
              <Route path='create_task' element={<TaskForm />} />
              <Route path='task_page/:id' element={<TaskPage />} />
            </Route>
            <Route path='/:ecgId/*' element={<EcgAnalysis />} />
            <Route path='/:ecgId/clustering/*' element={<Clustering />} />
            <Route path='/' element={<EcgList />} />
            <Route path='*' element={<NotFound />} />
          </Routes>
        </Authenticator>
      </Page>
    </AppProviders>
  );
};
